// type safe paths
// https://github.com/garybernhardt/static-path
//
// tip: unless you're adding the route to the router, always call these as a
// function even if they don't take parameters
// e.g.  <Link to={rootPath({})}> and not <Link to={rootPath.pattern}>

import { path } from 'static-path'

export const rootPath = path('/')
export const loginPath = path('/login')
export const credentialsLoginPath = path('/login/credentials')
export const detailsPath = path('/details')
export const profilePath = path('/profile')
export const profileEditPath = path('/profile/edit')
export const dashboardPath = path('/dashboard')
export const usersPath = path('/users')
export const emailAuthPath = path('/auth/email/:email/:token/:clientAuthCode')

export const playlistsPath = path('/playlists')
export const playlistPath = path('/playlists/:playlistId')
export const newPlaylistPath = path('/playlists/new')
export const zonesPath = path('/zones')
export const zonePath = path('/zones/:zoneId')
export const zoneBillingPath = path('/zones/:zoneId/billing')
export const schedulesPath = path('/schedules')
export const schedulePath = path('/schedules/:scheduleId')
export const editSchedulePath = path('/schedules/:scheduleId/edit')
export const newSchedulePath = path('/schedules/new')
export const reportingPath = path('/reporting')

export const voiceMessagesPath = path('/voice-messages')
export const voiceMessagePath = path('/voice-messages/:voiceMessageId')
export const newVoiceMessagePath = path('/voice-messages/new')
export const editVoiceMessagePath = path('/voice-messages/:voiceMessageId/edit')
export const voiceMessageSchedulesPath = path('/voice-messages/:voiceMessageId/schedules')
export const newVoiceMessageSchedulePath = path('/voice-messages/:voiceMessageId/schedules/new')
export const editVoiceMessageSchedulePath = path(
  '/voice-messages/:voiceMessageId/schedules/:scheduleId/edit',
)
export const newVoiceMessageSchedulePathForMessage = (
  voiceMessageId: string,
) => `/voice-messages/${voiceMessageId}/schedules/new`

export const voicePlaylistRequestsPath = path("/voice-playlist-requests")

export const spotifyPath = path("/spotify")
export const tracksPath = path("/tracks")
export const trackPath = path("/tracks/:trackId")
export const newTrackPath = path("/tracks/new")
export const editTrackPath = path("/tracks/:trackId/edit")

export const billingPath = path('/billing')
export const organizationSettingsPath = path('/settings/organization')
